import { render, staticRenderFns } from "./StateAnxiety.vue?vue&type=template&id=64c343b0&scoped=true"
import script from "./StateAnxiety.vue?vue&type=script&lang=js"
export * from "./StateAnxiety.vue?vue&type=script&lang=js"
import style0 from "./StateAnxiety.vue?vue&type=style&index=0&id=64c343b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c343b0",
  null
  
)

export default component.exports